import { useEffect } from 'react';
import Footer from '../../Utils/Footer/footer-component'
import Contact from './Contact.js';
import Layout from '../../Utils/Navbar/navbar-layout-component.js';

function ContactScreen() {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="flex w-full flex-col">
            <div>
                <Layout>
                    <Contact />
                </Layout>
                <Footer />
            </div>

        </div>
    );
}

export default ContactScreen;